// https://github.com/bfred-it/object-fit-images
// https://github.com/scottjehl/picturefill
// https://isotope.metafizzy.co
// https://idiotwu.github.io/smooth-scrollbar/

require('intersection-observer')
window.jQuery = window.$ = require('jquery')

//require('popper.js/dist/umd/popper.min.js')
require('bootstrap/js/dist/util.js')
//require('bootstrap/js/dist/collapse.js')
//require('bootstrap/js/dist/scrollspy.js')
require('bootstrap/js/dist/modal.js')
require('bootstrap/js/dist/tab.js')

require('./ScrollConverterWindow')

/* IE11 Polifills */
// https://barba.js.org/docs/getstarted/browser-support/
require('es6-promise').polyfill(); // for barbajs, webpack dynamic import
// https://github.com/zloirock/core-js
// import 'core-js'
import 'core-js/features/array';
import 'core-js/features/object';
import 'core-js/features/number';
import 'core-js/features/dom-collections/for-each'
import 'core-js/web/dom-collections'
import 'core-js/features/dom-collections/iterator'
/* IE11 Polifills */

import { gsap } from "gsap"
import barba from '@barba/core'
//import barbaCss from '@barba/css'

import utils from './modules/utils'
import iocallback from './modules/iocallback'
import carousel from './modules/carousel'
import parallaxHeader from './modules/parallax_header'
import timeline from './modules/timeline'
import toggleclassObserver from './modules/toggleclass_observer'
import parallaxSection from './modules/parallax_section';
import tip from './modules/tip';
import audio from './modules/audio';
import barbaSetup from './modules/barba_setup';
import LazyLoad from 'vanilla-lazyload'
require('./modules/modernizr')

let lazyLoadInstance = null

$.expr[':'].external = function(obj){
    return !obj.href.match(/^mailto\:/)
           && (obj.hostname != location.hostname)
           && !obj.href.match(/^javascript\:/)
           && !obj.href.match(/^$/)
};

const mainContentForTouch = false
const $html = $('html')
const $body = $('body')
const $window = $(window)
window.app = {
  $html: $html,
  $body: $body,
  $window: $window,
  isTouch: function () {
    if(typeof(Modernizr) === 'object'){
      return (Modernizr.touchevents)
    }else{
      // return (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch) || window.navigator.msPointerEnabled)
      // return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
      return (
        !!(typeof window !== 'undefined' &&
          ('ontouchstart' in window ||
            (window.DocumentTouch &&
              typeof document !== 'undefined' &&
              document instanceof window.DocumentTouch))) ||
        !!(typeof navigator !== 'undefined' &&
          (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
      )
    }
  },
  isIos: function () {
    // return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  },
  isPortrait: function () {
    // when keaborad is open, poprtrait smartphone became landscape! prevent this!
    return (window.innerWidth < window.innerHeight) || (window.innerWidth < 992)
  },

  // Bootstrap 4 breakpoints
  isXs: function () {
    return window.innerWidth < 576
  },
  isSm: function () {
    return window.innerWidth >= 576
  },
  isMd: function () {
    return window.innerWidth >= 768
  },
  isLg: function () {
    return window.innerWidth >= 992
  },
  isXl: function () {
    return window.innerWidth >= 1200
  },
  lazyUpdate: function(){
    if (lazyLoadInstance) {
        lazyLoadInstance.update()
    }
  },
  headerHeight: function() {
    return $('header.mhead').height()
  },
  scrollTo: function(selector, offset, duration ){
    if (typeof(duration) === 'undefined') {
      duration = 400
    }

    let scrollDestination = 0
    let scrollDestinationX = 0
    let dataScrollOffset = null
    if (typeof(selector) === 'string') {
      const $destination = $(selector)
      if ($destination.length) {
        const destinationOffset = $destination.offset()
        scrollDestination = destinationOffset.top
        scrollDestinationX = destinationOffset.left
        dataScrollOffset = ($destination.attr('data-scroll-offset')) ? parseInt($destination.attr('data-scroll-offset'), 10) : null
      }
    } else if (typeof(selector) === 'number') {
      scrollDestination = selector
    } else if (typeof(selector) === 'object') {
      if (selector.length) {
        scrollDestination = selector.offset().top
      }
    }

    if(typeof(offset) !== 'number'){
      offset = (dataScrollOffset !== null) ? dataScrollOffset : (window.app.headerHeight() + 30)
    }

    if(scrollDestination && mainContentForTouch && window.app.isTouch()) {
      $('#main-content').animate({
        scrollTop: scrollDestination - offset,
        scrollLeft: scrollDestinationX
      }, duration);
    } else {
      $('html, body').animate({
        scrollTop: scrollDestination - offset,
        scrollLeft: scrollDestinationX
      }, duration);
    }
  },

  // https://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls
  checkDomain: function(url) {
    if ( url.indexOf('//') === 0 ) { url = location.protocol + url; }
    return url.toLowerCase().replace(/([a-z])?:\/\//,'$1').split('/')[0];
  },
  isExternal: function(url) {
    return ( ( url.indexOf(':') > -1 || url.indexOf('//') > -1 ) && window.app.checkDomain(location.href) !== window.app.checkDomain(url) );
  },
  goTo: function(url) {
    if (window.app.isExternal(url)) {
      if ( (url.indexOf('|modal')!== -1) && typeof(window.app.openIframeModal) === 'function') {
        window.app.openIframeModal(url.replace('|modal', ''))
      } else {
        window.open(url)
      }
    } else {
      barba.go(url)
    }
  },
  // Iframe modal
  openIframeModal: function(iframeSrc) {
    const modalMarkup = '<div class="modal fade" id="modalIframe" tabindex="-1" role="dialog" aria-labelledby="modalIframeTitle" aria-hidden="true">' +
      '<div class="modal-close">' +

      '<button type="button" class="btn btn--burger btn--burger-close" data-dismiss="modal" aria-label="Close">' +
      '  <span class="burguer-wrapper">' +
      '    <span class="burger-line burger-line-1"></span>' +
      '    <span class="burger-line burger-line-2"></span>' +
      '    <span class="burger-line burger-line-3"></span>' +
      '  </span>' +
      '</button>' +

      '</div>' +
      '<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-iframe" role="document">' +
        '<div class="modal-content">' +
          '<div class="embed-responsive embed-responsive-16by9">' +
              '<iframe class="embed-responsive-item" src="' + iframeSrc + '" allow="autoplay; encrypted-media" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>'
    $body.append(modalMarkup)

    setTimeout(()=>{
      $('#modalIframe').on('show.bs.modal', function (e) {
        $body.addClass('modal-open--scroll-unlock')
      }).on('hidden.bs.modal', function (e) {
        $body.removeClass('modal-open--scroll-unlock')
        $('#modalIframe').remove()
      }).modal('show')
    }, 0)
  },

  /*
  * App utility to append script to document body
  */
  addedScripts: [],
  addScript: function( src, callback ) {
    if (window.app.addedScripts.indexOf(src) === -1) {
      window.app.addedScripts.push(src)
      var s = document.createElement( 'script' )
      s.setAttribute( 'src', src )
      s.onload=callback
      //document.querySelector('#barba-wrapper .barba-container').appendChild( s )
      document.body.appendChild( s )
    } else {
      callback()
    }
  },

  progressBarrSelector: '#progress-bar',

  triggerEvent: function(eventName, args) {
    $window.trigger(eventName, args)
  }
}

/*
 * Select "got to url on change"
 */
const selectChangeLocation = function(e) {
  /*
  let optionSelected = $("option:selected", this);
  let url = optionSelected.val(); //.text();
  */
  let url = $(this).val()
  if (url) {
    //window.location.href = url
    barba.go(url)
  }
}

const barbaChangeLocation = function(e, url) {
  if (url) {
    //window.location.href = url
    barba.go(url)
  }
}

const modalIframeClickHandler = function(e){
  let iframeSrc = $(this).attr('data-open-iframe')
  if (iframeSrc && typeof(window.app.openIframeModal) === 'function') {
    e.preventDefault()
    window.app.openIframeModal(iframeSrc)
  }
}

const shareUrlFormat = function(str){
    var url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    str = str.replace(/%url%/g, encodeURIComponent(url));
    str = str.replace(/%title%/g, $('title').text());
    return str;
}

const scrollToHash = function(hash) {
  window.app.scrollTo(hash)
  window.location.hash = hash;
}

const pageViewInit = function(nextContainer){
  $('a:external').attr('target', '_blank').attr('rel', 'noopener').attr('data-barba-prevent', 'self');
  $('#sub-header').clone().attr('id', 'sub-header--fixed').addClass('visible-on-scroll-out').prependTo('.barba-container')

  carousel.init()
  parallaxHeader.init()
  timeline.init()
  toggleclassObserver.init()
  parallaxSection.init()
  iocallback.init()
  audio.init()
  window.app.lazyUpdate()
  $window.trigger('app:page_init')
}

const pageViewDestroy = function(currentContainer){
  toggleclassObserver.destroy()
  carousel.destroy()
  parallaxHeader.destroy()
  parallaxSection.destroy()
  timeline.destroy()
  iocallback.destroy()
  audio.destroy()
}

$(document)
  .ready(function(){
    //Object-fit polyfill
    //https://github.com/bfred-it/object-fit-images
    if(typeof(objectFitImages)==='function'){
      objectFitImages(null, {watchMQ: true})
      //objectFitImages()
    }

    // lazy load images in isotope items
    $window.on('more:items-appended', window.app.lazyUpdate)

    $window.on('sub-header-out', function(){
      $('#sub-header--fixed').addClass('show');
    })
    $window.on('sub-header-in', function(){
      $('#sub-header--fixed').removeClass('show');
    })

    if(mainContentForTouch){
      $html.addClass('scroll-main-content')
    }

    // disable browser scroll restoration
    // https://github.com/barbajs/barba/issues/158
    // https://barba.js.org/docs/advanced/recipes/#Scroll-position
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    // reset position of the loading screen
    barbaSetup.initLoader()
    barbaSetup.initBarba(pageViewInit, pageViewDestroy)

    // https://github.com/verlok/lazyload#-api
    // masonry.destroy()
    lazyLoadInstance = new LazyLoad({
      callback_loaded: (el)=>{
        // masonry.update()
        $window.trigger('image_loaded')
      },
      elements_selector: '.lazy',
      load_delay: 300 //adjust according to use case
    });

    let currentScroll = 0
    const windowScroll = function(){
      const scrollPos = $window.scrollTop()
      if(scrollPos < 180) {
        $body.removeClass('is-scrolled')
      } else {
        if (scrollPos > currentScroll) {
          $body.addClass('is-scrolled')
        } else if (scrollPos < currentScroll) {
          $body.removeClass('is-scrolled')
        }
      }
      currentScroll = scrollPos
    }
    const resizeHandler = function() {
      windowScroll()
			document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px')
		}
    const resizeHandlerThrottle = utils.debounce(resizeHandler, 200)
    const windowScrollThrottle = utils.throttle(windowScroll, 200)

    resizeHandler()
    $window
			.resize(resizeHandlerThrottle)
			.scroll(windowScrollThrottle)

    /*
    * open displaimer modal!
    */
    if(window.location.hash){
      let hashValue = window.location.hash.substr(1);
      if($('.modal-' + hashValue).length){
        $('.modal-' + hashValue).first().modal('show');
      } else {
        scrollToHash(window.location.hash)
      }
    }

    // Listen Shown Modal Event and update caorusel size
    // $window.on('shown.bs.modal', function (e) {
    //   setTimeout(() => {
    //     carousel.update()
    //   }, 100)
    // })

    $window.on('barbaChangeLocation', barbaChangeLocation)

    tip.appInit()
    audio.appInit()
  })
  .on('click', 'a', function(e) {
      var href = $(this).attr('href'); //this.href returns the complete url#something

      // href starts with # : is it an anchor?
      if( /^#/.test(href) && !$(this).attr('data-toggle')) { // if (this.hash) {
        e.preventDefault(); //defaults(e);
        var hash = this.hash;
        // scrollto with hash link in-page
        if(hash) {
          scrollToHash(hash)
        }
      }

      // prevent reload on same link
      if(href === window.location.href) {
        e.preventDefault();
        e.stopPropagation();
      }

      // Open modals to be closed?
      $('.modal').modal('hide')
  })
  /*
  .on('click', '[data-open-window]', function(e){
    e.preventDefault();
    if($(this).attr('data-urlpattern')){
      const formatted = shareUrlFormat($(this).attr('data-urlpattern'));
      window.open(formatted, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=440,width=600');
    }
  })
  */
  /*
  .on('click', '[data-share-toggle]', function(e){
    // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
    e.preventDefault();

    var url = window.location.href
    const canonicalElement = document.querySelector('link[rel=canonical]')
    if(canonicalElement !== undefined) {
      url = canonicalElement.href
    }
    const pageTitle = $('title').text()
    const pageDescription = $('meta[name="description"]').attr('content')
    const shareData = {
      title: pageTitle,
      text: pageDescription,
      url: url,
    }
    if(typeof navigator.share !== 'undefined'){
      navigator.share(shareData)
        .then(function() { console.log("Share success!"); })
        .catch(function() { console.log("Share failure!"); })
    } else {
      const $parent = $(this).parent()
      $parent.toggleClass('share-tool-active')
      if ($parent.hasClass('share-tool-active')) {
        $(document).on('click', shareToggleOnDocumentClick)
      }
    }
  })
  */
  .on('click', '[data-open-iframe]', modalIframeClickHandler)
  .on('click', '[data-menutoggle]', function(e){
    $html.toggleClass('navigation-panel--open')
  })
  .on('click', '[data-goto-url]', function(e){
    barba.go($(this).attr('data-goto-url'))
  })
  .on('click', '[data-show]', function(e){
    e.preventDefault()
    const $el = $(this)
    $el.hide()
    const $target = $($el.attr('data-show'))
    if ($target.length) {
      $target.show()
    }
  })
  // .on('change', '[data-change-location]', selectChangeLocation)
